import { useContext } from "react";
import PhotoCarousel from "../flight-brief/PhotoCarousel";
import PoweredByContext from "../../store/PoweredByContext";

const AircraftPreview = ({ recommended, photoData }) => {
    const poweredByCtx = useContext(PoweredByContext);

    return (
        <div className="aircraft-card aircraft-card--preview">
            <div className="aircraft-card__content">
                <div className="aircraft-card__photos-browser">
                    <PhotoCarousel
                        photoData={photoData}
                        bannerTitle={recommended ? (poweredByCtx.isPoweredBy ? "Recommended" : "Shy Recommends") : null}
                    />
                </div>
            </div>
        </div>
    );
};

export default AircraftPreview;
